export default "__VITE_ASSET__53f4af5e__"